import { styled } from "@mui/material";
import { InfoContainer } from "./InfoContainer";

export const ReasonContainer = styled(InfoContainer)(() => ({
  minHeight: "3rem",
  marginBottom: 0,
}));
